function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#00AAEC",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 3.018c-1.102.511-2.29.858-3.534 1.012 1.271-.795 2.247-2.056 2.706-3.559-1.19.737-2.505 1.273-3.91 1.56C24.141.78 22.54 0 20.77 0c-3.397 0-6.153 2.881-6.153 6.435 0 .504.053.994.158 1.465-5.115-.269-9.65-2.828-12.687-6.725-.53.953-.832 2.06-.832 3.238 0 2.232 1.086 4.202 2.738 5.356-1.008-.031-1.958-.324-2.79-.803v.08c0 3.118 2.122 5.72 4.94 6.309-.516.15-1.06.226-1.622.226-.396 0-.784-.038-1.159-.114.784 2.556 3.055 4.417 5.75 4.467C7.007 21.66 4.35 22.69 1.469 22.69.972 22.69.48 22.66 0 22.6c2.724 1.823 5.96 2.89 9.435 2.89 11.322 0 17.512-9.805 17.512-18.309 0-.28-.006-.56-.016-.834 1.202-.908 2.247-2.04 3.069-3.33"
}));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.15dbaecb.svg";
export { ForwardRef as ReactComponent };